import React, { useEffect } from 'react';
import {
  ButtonWithAction,
  FormInput,
  Cluster,
  constants,
  Box,
} from '@thecb/components';
import { SearchIcon } from '../../components/search-icons';
import styled from 'styled-components';

const DrawerHistorySearchInputWrapper = styled.div`
  .searchDrawerHistoryIDSearchIcon {
    width: 2rem;
  }

  .searchDrawerHistoryIDInput {
    border: 0;
    width: 860px;
    margin-top: 0.25rem;
  }
`;

const DrawerHistorySearchInput = ({
  fields,
  actions,
  clear,
  shouldClear,
  fetchData,
  handleSubmit,
}) => {
  useEffect(() => {
    if (shouldClear) {
      actions.fields.id.set('');
      fetchData({ pageIndex: 1 });
    }
  }, [shouldClear]);

  const searchErrors = {};

  return (
    <DrawerHistorySearchInputWrapper>
      <Cluster
        childGap="0.25rem"
        justify="space-around"
        align="center"
        minHeight="100%"
        minWidth="100%"
      >
        <Cluster
          extraStyles={`overflow: visible;`}
          align="center"
          justify="space-between"
        >
          <Box padding="0px 12px 0px 0px">
            <SearchIcon color={constants.colors.LUCKY_POINT} />
          </Box>
          <FormInput
            placeholder="Enter Batch Number or Cash Action ID to search"
            themeValues={{ lineHeight: 0 }}
            data-testid="drawer-history-ID"
            className="searchDrawerHistoryIDInput"
            errorMessages={searchErrors}
            field={fields.id}
            errors={fields.id.errors}
            fieldActions={actions.fields.id}
            labelTextVariant="p"
            errorTextVariant="p"
          />
        </Cluster>
        <ButtonWithAction
          type="reset"
          variant="smallGhost"
          text={'Clear Search'}
          data-testid="drawerHistoryIDClearSearch"
          action={() => {
            clear();
          }}
        />
        <ButtonWithAction
          type="submit"
          minWidth="0"
          width="3rem"
          padding=".5rem"
          minHeight="0"
          extraStyles={`line-height: 1;`}
          data-testid="drawer-history-submit-filters"
          variant="primary"
          contentOverride={true}
          action={handleSubmit}
        >
          <SearchIcon
            color={constants.colors.WHITE}
            className="searchDrawerHistoryIDSearchIcon"
          />
        </ButtonWithAction>
      </Cluster>
    </DrawerHistorySearchInputWrapper>
  );
};

export { DrawerHistorySearchInput };
